import BaseComponent from '../base_component/base_component'
import {validatePassword} from '../scripts/validate_password/validate_password'

export default class ChangePassword extends BaseComponent {
    constructor(id: number, component_name: string) {
        super(id, component_name);
        $(this.component).find('#old_password').focus();
        this.addAsyncHooks();
    }

    addAsyncHooks() {
        this.find('#confirm').keyup(event => {
            let oldPassword = $('#new_password').val();
            let isMatch = oldPassword === $(event.target).val();
            this.whenInactiveFor(300, () => {
                let hint = this.find('#change_password_error');
                hint.text(isMatch ? '' : 'Password and confirmed password must be the same.');
                hint.toggle(!isMatch);
            });
        });
        this.find('#new_password').keyup(event => {
            let password = $(event.target).val();
            let result = password.length < 3 ? null : validatePassword(password);
            this.whenInactiveFor(300, () => {
                let hint = this.find('#change_password_error');
                hint.text(result);
                hint.toggle(!!result);
            });
        });
    }

    whenInactiveFor(time, callback) {
        let timeout = this.timeoutId = setTimeout(() => {
            this.timeoutId == timeout ? callback() : null
        }, time)
    }

    validate($this: JQuery, $: JQueryStatic) {
        $ = $ || window.$;
        $this = $this || $(this.component);
        var old_password = $.trim(($this.find('#old_password').val(): any));
        var new_password = $.trim(($this.find('#new_password').val(): any));
        var confirm = $.trim(($this.find('#confirm').val(): any));
        let validationResult = validatePassword(new_password);
        if (old_password == '') {
            $this.find('#change_password_error').show();
            $this.find('#change_password_error').text("You must enter your old password.");
            $this.find('#old_password').focus();
            return false;
        } else if (validationResult) {
            $this.find('#change_password_error').text(validationResult);
            this.clearPasswords($this);
            return false;
        } else if (new_password != confirm) {
            $this.find('#change_password_error').text("Password and confirmed password must be the same.");
            this.clearPasswords($this);
            return false;
        } else {
            $this.find('#change_password_error').hide();
            $this.find('button#change_password').prop('disabled', true);
            return true;
        }
    }

    clearPasswords($this: JQuery) {
        $this.find('#change_password_error').show();
        $this.find('#new_password').val('');
        $this.find('#confirm').val('');
        $this.find('#password').focus();
    }
}